export default {
  list: {
    data: null,
    loading: false,
    error: null
  },
  listDestinationUrls: {
    data: null,
    loading: false,
    error: null
  }
}
